// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1HVFF","footer":"ModalInfo_footer__3-Gx_"};